module.exports = __webpack_public_path__ + "static/Sabine_Condiescu-7de509c2b69ae2009aff0838bfb02c79.webp";